export const DeviceType = {
  Mobile: "Mobile",
  Tablet: "Tablet",
  Web: "Web",
}
